import { fhirClient } from "src/App";
import { apiClient } from "src/careflow/ph-core/api_client/api_client";
import { OrganizationWrapper } from "src/careflow/ph-core/fhir-client/fhir-base/wrappers/Organization";
import { Bundle, Organization } from "src/careflow/ph-core/fhir-client/resources";

export type SearchOrganizations = {
  typeIdentifier: any;
  identifier: string | null;
  name: string | null;
  type: any;
  street1: string | null;
  street2: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
};

const organizationPath = 'organizations';

export async function searchOrganizations(
  filters: SearchOrganizations, 
  fhirUrl: string,
  useMasterIndex: boolean = false,
) {
  const {
    typeIdentifier,
    identifier,
    name,
    type,
    street1,
    street2,
    city,
    state,
    zipCode
  }: SearchOrganizations = filters;
  
  const system = typeIdentifier?.system?.trim();
  const id = identifier?.trim();

  const identifiers: string[] = [];

  if (system && id) {
    identifiers.push(`${system}|${id}`);
    identifiers.push(`${fhirUrl}|${id}`);
  } else if (id) {
    identifiers.push(id);
  } else if (system) {
    identifiers.push(system);
  }

  const organizationFilters = {
    ...(identifiers.length > 0
      ? {
          identifier: identifiers.join(','),
        }
      : {}),
    ...(name?.trim()
      ? {
          name: name.trim(),
        }
      : {}),
    ...(type?.code?.trim()
      ? {
          type: type.code.trim(),
        }
      : {}),
    ...(city?.trim()
      ? {
          'address-city': city.trim(),
        }
      : {}),
    ...(state?.trim()
      ? {
          'address-state': state.trim(),
        }
      : {}),
    ...(zipCode?.trim()
      ? {
          'address-postalcode': zipCode.trim(),
        }
      : {}),
    ...(street1?.trim() || street2?.trim()
      ? {
          address: [street1, street2]
          .filter(Boolean)
          .map((s) => s?.trim())
          .join(' '),
        }
      : {}),
  };

  let result: any = {};

  if(useMasterIndex){
    result = await apiClient.get(`${organizationPath}/search?${organizationFilters}`)
  }else {
    const data = await fhirClient.search(
      `Organization?${new URLSearchParams(organizationFilters).toString()}`
    );
    result = data?.entry?.map?.(({ resource }) =>
      resource ? OrganizationWrapper(resource as Organization) : {}
    ) ?? [];
  }

  return result;
}

export async function activateFhirOrganization(fhirId: string){
  const url = `/core/organization/${fhirId}/activate`;
  const data  = await apiClient.post(url, {});

  return data;
}

export async function deactivateFhirOrganization(fhirId: string){
  const url = `/core/organization/${fhirId}/deactivate`;
  const data = await apiClient.post(url, {});

  return data;
}